<template>
  <TButton :inverse="inverse" @click="openDropper">
    <template #icon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width="14"
        height="14"
      >
        <path
          d="M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"
          fill="currentColor"
        />
      </svg>
    </template>
  </TButton>
</template>

<script setup>
import TButton from "../../TButton/TButton.vue";

const emits = defineEmits(["chooseColor"]);
defineProps({
  inverse: {
    type: Boolean,
    default: false,
  },
});

function openDropper() {
  const eyeDropper = new EyeDropper();

  eyeDropper
    .open()
    .then((result) => {
      console.log(result.sRGBHex);
      emits("chooseColor", result.sRGBHex);
    })
    .catch((e) => {
      console.error(e);
    });
}
</script>
